export default __webpack_public_path__ + "static/media/empty.8d3b07b7.svg";